import React from "react";
import ShortCoursesHeader from "../components/Courses/ShortCourses/ShortCoursesHeader";
import ShortCoursesCareerSkills from "../components/Courses/ShortCourses/ShortCoursesCareerSkills";
import ShortCoursesProgramsCard from "../components/Courses/ShortCourses/ExploreProgramsShortCourses";
import ShortCoursesAdmissionRequirements from "../components/Courses/ShortCourses/ShortCoursesAdmissionRequirements";
import FullScreenImage from "../components/Home/ShowcaseSection";
import Footer from "../components/sub-comp/MainFooter";
import Navbar from "../components/sub-comp/Navbar";

const ShortCourses = () => {
  return (
    <div>
      <Navbar />
      <ShortCoursesHeader />
      <ShortCoursesCareerSkills />
      <ShortCoursesProgramsCard />
      <ShortCoursesAdmissionRequirements />
      <FullScreenImage />
      <Footer />
    </div>
  );
};

export default ShortCourses;
